<template>
  <div>
    <el-dialog center width="80%" class="abow_dialog" :lock-scroll="false" :before-close="closeDialog" :visible.sync="visible">
      <div v-if="type == 'overseas'">
        <iframe :src="html" width="100%" height="500px" frameborder="0"></iframe>
      </div>
      <div v-if="type == 'tracking'">
        <iframe :src="gzHtml" width="100%" height="500px" frameborder="0"></iframe>
      </div>
      <div v-if="type == 'pay'">
        <iframe :src="payHtml" width="100%" height="500px" frameborder="0"></iframe>
      </div>
      <div v-if="!type">
        <iframe :src="cpsHtml" width="100%" height="500px" frameborder="0"></iframe>
        <!-- <div slot="title">
          <span style="font-size: 20px"><strong>e航无忧 – VGM、舱单数据发送服务协议</strong></span>
        </div>
        <div style="height: 500px; overflow: auto;">
          <p>甲方：任何使用本产品及服务的客户</p>
          <p>乙方：上海猿航科技有限公司</p>
          <p>联系地址：上海市普陀区真南路822弄129号麦腾科技园3号楼</p>
          <p>乙方向甲方授权并允许甲方使用乙方自主研发的VGM、舱单数据发送服务，双方签署并共同遵循如下软件及服务协议：</p>
          <p class="clause"><strong>第一条 服务内容</strong></p>
          <p class="matter_1">1.1 乙方通过其自主研发的e航无忧应用平台（https://app.eline56.com/）向甲方提供VGM、舱单数据发送服务。</p>
          <p class="matter_1">1.2 甲方在使用乙方所提供的VGM、舱单数据发送服务前，务必仔细阅读乙方软件产品在页面醒目位置所展示的最新消息提醒，并在充分理解和知悉上述提醒的前提下使用乙方所提供的产品及服务。</p>
          <p class="matter_1">1.3 甲方需要通过上述平台完成账号注册，并上传营业执照或授权书等相关资料以完成企业实名认证。</p>
          <p class="matter_1">1.4 甲方通过乙方平台自行填报相关数据信息，并通过乙方所提供的VGM、舱单数据发送服务（发送服务形式包含但不仅限于API接口、邮件、其他信息传递工具等）将填报的数据发送给外部第三方接收方。</p>
          <p class="clause"><strong>第二条 许可期限</strong></p>
          <p class="matter_1">甲方通过乙方所提供的平台完成用户注册并勾选服务协议即代表本协议开始生效，本协议生效后乙方向甲方提供本协议所约定的软件及服务，有效期直至甲方不再使用乙方提供的软件及服务，或通知乙方终止提供服务为止。</p>
          <p class="clause"><strong>第三条 甲方的权利义务</strong></p>
          <p class="matter_1">3.1 甲方在乙方平台完成账号注册并确认开通相应服务后，方可使用上述软件及服务。</p>
          <p class="matter_1">3.2 甲方通过账号和密码登录乙方平台的所有操作均被视为甲方授权的操作人员，在此账号下的所有操作默认均是合法、合规的行为。甲方应妥善保管自己的账号和密码，不得公开或告知任何第三方，此外</p>
          <p class="matter_2">3.2.1 若因甲方原因导致的账号或密码遗忘和遗失，应及时通知乙方帮其找回。如特殊原因无法找回，应立即停止当前账号及密码的使用；</p>
          <p class="matter_2">3.2.2 若因甲方原因导致的账号和密码被第三方获取并使用，乙方有权终止提供服务并解除本协议，由此产生的所有后果和责任均由甲方承担。</p>
          <p class="matter_1">3.3 甲方在乙方平台上所填报的任何数据有取消或变更应及时通知乙方客服人员，若通知不及时所造成的一切后果均由甲方自行承担（如退单、罚款等），乙方不承担任何责任。</p>
          <p class="matter_1">3.4 甲方应根据自身或有关部门规定的业务期限，及时在乙方平台上完成VGM、舱单数据发送，若因甲方原因未及时填报数据及发送所产生的一切后果均由甲方自行承担，乙方不承担任何责任。</p>
          <p class="matter_1">3.5 乙方仅作为VGM、舱单数据发送平台为甲方提供相应服务，对于甲方所填报数据的真实性、合法性和完整性等乙方没有审核的义务，也不承担相应的法律责任，甲方应自行对其填报的数据承担全部法律责任。若因甲方原因出现数据填报错误、数据过时等问题，乙方不承担相应法律责任，并有权拒绝发送或单方面终止本协议。</p>
          <p class="matter_1">3.6 甲方应当遵守本协议规定的内容，不得非法使用乙方所提供的平台从事损害乙方或其他第三方利益的行为。因甲方使用不当所造成的一切损失均由甲方自行承担（包括但不仅限于政府有关部门的罚款、对第三方的违约、侵权赔偿、商业信誉的损失、乙方因维护自身合法权益而支出律师费、取证费、诉讼费、保全费等损失）。</p>
          <p class="matter_1">3.7 甲方不得上传与数据发送服务无关的信息，包括但不仅限于非法文件、木马程序、病毒、无效数据等。</p>
          <p class="matter_1">3.8 甲方不得利用乙方平台的漏洞或故障进行任何不正当的操作以谋取私利，不得损害乙方或第三方的利益。</p>
          <p class="matter_1">3.9 甲方不得对乙方提供的数据发送平台进行任何反编译、破解或逆向工程操作，不得非法复制、模仿乙方的数据发送平台，否则由于非法操作给乙方造成的一切直接或间接损失均由甲方承担。</p>
          <p class="clause"><strong>第四条 乙方的权利义务</strong></p>
          <p class="matter_1">4.1 甲方使用乙方所提供的VGM、舱单数据发送服务，乙方应及时并客观的反映甲方所填数据的发送状态，乙方有权依据该项服务向甲方收取相应费用。</p>
          <p class="matter_1">4.2 乙方仅作为数据发送平台为甲方提供数据发送服务，对于甲方所填报数据的真实性、准确性和完整性没有审核的能力和义务，也不承担任何法律责任。</p>
          <p class="matter_1">4.3 乙方在协议有效期内有义务保存甲方在数据发送平台填写的数据信息以及发送记录等，方便甲方根据实际需要查询。</p>
          <p class="matter_1">4.4 乙方不得以任何理由非法获取并使用甲方所填报的数据信息以谋取私利，若因乙方原因（除不可抗力外）导致的甲方数据泄露、丢失等，乙方应承担法律责任并提供相应赔偿。</p>
          <p class="matter_1">4.5 若甲方违反《中华人民共和国网络安全法》、非法使用乙方平台进行数据发送或侵害外部第三方权利等，乙方有权要求甲方删除此类数据和信息、停止违法行为。甲方在收到乙方通知后应立即遵守此类请求。若未遵守，乙方有权终止本协议并收回甲方使用平台的权限，乙方对甲方因此遭受的损失不承担任何责任。因此给乙方或者第三方造成的一切损失（包括但不限于政府有关部门的处罚、对第三方的赔偿、商誉损失、律师费、取证费、诉讼费、保全费等），甲方需予以赔偿。</p>
          <p class="matter_1">4.6 乙方应保证数据发送平台和网络设备的正常使用。如发生故障，乙方应及时通过网络渠道通知甲方，并在故障排除后再次通知甲方问题已解决。在故障发生期间，数据发送服务中止。对于因不可抗力（包括但不限于发生地震、水灾、旱灾等自然灾害、战争、罢工、政府禁令、电信部门技术调整或线路出现故障、电力系统故障等）导致的平台故障，乙方不承担任何责任。</p>
          <p class="matter_1">4.7 甲方应保证账户中金额充足，在甲方未支付应付费用或账户欠费、余额不足的情况下，乙方有权中止一切服务，由此造成的一切后果由甲方自行承担，乙方不承担任何责任。</p>
          <p class="clause"><strong>第五条 开票</strong></p>
          <p class="matter_1">甲方在乙方数据发送平台上充值，并使用乙方提供的VGM、舱单数据发送服务，乙方应开具增值税普通发票（电子票或纸质票），开票次数最多为每月两次，如甲方多次充值，可以合并开具发票。</p>
          <p class="clause"><strong>第六条 违约责任</strong></p>
          <p class="matter_1">6.1 双方均应严格遵守本协议条款，若未按本协议执行则将视作违约。任何一方不履行义务或者履行义务不符合约定的，应当承担继续履行、采取补救措施或者赔偿损失等违约责任。</p>
          <p class="matter_1">6.2 协议一方违反本协议约定或法定义务，造成另一方受到相应行政处罚的，由违约方承担相应的责任，给另一方造成经济损失的，违约方应当进行赔偿。</p>
          <p class="clause"><strong>第七条 知识产权</strong></p>
          <p class="matter_1">7.1 本协议将不会引起任何知识产权所有权的转移。</p>
          <p class="matter_1">7.2 甲方承认乙方向甲方提供的任何资料、技术或技术支持、软件（原始程序或最终执行程序）、服务等的知识产权均归属于乙方或其关联方所有。</p>
          <p class="matter_1">7.3 以上及其他任何本协议所包含的内容和知识产权均受到法律保护，未经乙方事前书面许可，任何人不得以任何形式进行使用或创造相关衍生产品。</p>
          <p class="clause"><strong>第八条 保密</strong></p>
          <p class="matter_1">8.1 双方承诺，未经一方书面同意，有关本协议的内容及双方在履行本协议过程中所透露的该方或其客户的秘密和专有信息（定义见下），另一方不得以任何方式向任何第三方或本公司内与履行本协议无关的其他人员透露。双方同意，一方透露的秘密或专有信息，无论其为何种形式，均为该方的绝对财产，对方应予以严格保密。</p>
          <p class="matter_1">8.2 本条所称秘密和专有信息是指：在本协议开始之前或者之间透露的任何书面的或口头的，与一方的经营或产品策略和将来要推出的产品有关的信息和数据或任何因履行本协议而向对方披露的信息，包括但不限于：公司结构，经营数据，客户名单、商业数据、财务数据，许可证事项和费用，研究与开发计划，市场计划和未来的商业计划，任何概念，意见，数据，时间表，专有知识，设计，与一方的产品和相关技术有关的商业和技术信息，以及披露方注意到的或一方传递给另一方的任何文件或者信息载体；但是，如下信息不受此限：</p>
          <p class="matter_2">a) 已成为公知信息，而接收方对此并无过错；</p>
          <p class="matter_2">b) 披露时接收方已经知晓的信息；</p>
          <p class="matter_2">c) 接收方从第三方合法获得的信息，且未附加保密的义务；</p>
          <p class="matter_2">d）接收方并未使用保密信息，而自行研发获得的信息；</p>
          <p class="matter_2">e）披露方事先书面同意披露或使用的信息。</p>
          <p class="matter_1">8.3 一方发现“秘密或专有信息”发生泄露等事故时，应立即告知另外一方，经双方协商后采取合理处理措施。如一方因其故意或过失造成“秘密或专有信息”泄露，该方须承担由此给另一方造成的直接经济损失，且须及时采取必要措施将另一方损失控制在最小限度内，并承担因此产生的费用和责任。如一方未及时采取必要措施而导致损失扩大，则该方对另一方因此扩大的损失承担责任。</p>
          <p class="matter_1">8.4 本协议所涉及保密信息保密期限为永久保密。本协议合作期限内及本协议终止或者解除后，甲、乙双方承诺不向任何第三方（包括但不限于与对方构成商业竞争关系的企业、商业机构或者组织、个人）提供有关双方业务、技术等一切相关信息或者资料，否则由泄密一方承担相应的责任，并赔偿另一方因此造成的一切损失。</p>
          <p class="clause"><strong>第九条 不可抗力</strong></p>
          <p class="matter_1">9.1 如任何一方由于不可抗力而无法全部或部分履行其在本协议项下的任何义务，则该义务应在受不可抗力影响期间内在受影响的范围内中止履行。根据本条主张不可抗力的一方在必要时有权根据实际情况合理延期履行该义务。</p>
          <p class="matter_1">9.2 本协议所述之不可抗力是指不能预见、不能克服、不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断、黑客、网路堵塞、电信部门技术调整和政府管制等，但不包括主张不可抗力一方的财务困难。</p>
          <p class="matter_1">9.3 遭受不可抗力的一方应在不可抗力事件发生后三日内通过有效渠道通知另一方，并采取合理措施减轻损害的发生，同时向另一方提交有关部门出具的证明文件。在可能的情况下，遭受不可抗力的一方应在不可抗力结束后十日内恢复履行本协议。如果因不可抗力致使任何一方延迟履行本协议超过三十（30）日, 另一方有权向其发出通知后，终止本协议。</p>
          <p class="clause"><strong>第十条 争议的解决</strong></p>
          <p class="matter_1">10.1 因执行本合同发生争议，由当事人双方协商解决，协商不成提请有管辖权人民法院诉讼解决。</p>
          <p class="matter_1">10.2 本合同之订立、效力、解释、执行应适用中华人民共和国法律（不包括香港、澳门、台湾）。</p>
          <p class="clause"><strong>第十一条 其他</strong></p>
          <p class="matter_1">11.1 因协议一方违反本协议约定，但尚未造成严重后果的，另一方可以中止本协议的履行，直到违约方做出相应的保证和整改后，另一方重新履行本协议或提供相应服务。</p>
          <p class="matter_1">11.2 本协议生效后，乙方根据实际情况有权就相关条款进行变更或补充，甲方如需继续使用乙方所提供的数据发送服务，则视为同意该类变更或补充；甲方如不同意该类变更或补充，应立即通知乙方终止本协议并停止使用乙方的数据发送服务，乙方收到甲方的终止通知之日起终止本协议的履行，对于甲方账户中尚未使用的服务费用乙方应无息返还给甲方，双方无需就本协议终止向对方承担任何责任。</p>
          <p class="matter_1">11.3 本协议有效期为一年。在有效期届满前30个自然日内，如任何一方未向另一方提出到期终止本协议的要求，则本协议自动延期一年，以此类推，上述延期不受次数限制。</p>
          <p class="matter_1">11.4 以上内容最终解释权归上海猿航科技有限公司所有。</p>
        </div> -->
      </div>

    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ServiceAgreement',
  props: {
    visible: Boolean,
		type: String
  },
  data() {
    return {
			html: '/service.html',
      gzHtml: '/gz.html',
      cpsHtml: '/cps.html',
      payHtml: '/pay.html'
    }
  },
	created(){
		console.log(this.type)
	},
  methods: {
    // 关闭
    closeDialog(){
      this.$parent.serviceAgreementDialogVisible = false
    },
  }
}
</script>

<style lang="less" scoped>
@import "./cps_style.less";
/deep/ .el-dialog__header {
  border: none !important;
}
</style>